exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container {\n  display: flex;\n}\n\n.day-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n  width: 20px;\n}\n\n.day-container.selected {\n  background-color: #dedfe8;\n}\n\n.day-container.isPrevSelected {\n  border-top-left-radius: 25px;\n  border-bottom-left-radius: 25px;\n}\n\n.day-container.isNextSelected {\n  border-top-right-radius: 25px;\n  border-bottom-right-radius: 25px;\n}\n\n.day {\n  color: #888992;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.day.selected {\n  color: #080912;\n}\n", ""]);

// exports
